import { render, staticRenderFns } from "./ProductsOffersCarrousel.vue?vue&type=template&id=09383300&scoped=true"
import script from "./ProductsOffersCarrousel.vue?vue&type=script&lang=js"
export * from "./ProductsOffersCarrousel.vue?vue&type=script&lang=js"
import style0 from "./ProductsOffersCarrousel.vue?vue&type=style&index=0&id=09383300&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09383300",
  null
  
)

export default component.exports